import { CreateRenderFunction } from "@pdfking/reactivity/preact"

export const Icon = CreateRenderFunction({
  props: {
    class: "",
    name: "",
    title: "",
  },
  render() {
    return (
      <i class={`icon icon-${this.name} ${this.class}`} title={this.title} />
    )
  },
})
